import Grid from '@material-ui/core/Grid'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { getStyles } from 'isotope-client'
import withStyles from '@material-ui/core/styles/withStyles'
import { compose } from 'redux'
import Typography from '@material-ui/core/Typography'
import { PERIOD_SWITCH } from '../utils/constants'
import { LocalDate } from '../../../../utils/date/local-date'
import { DateUnit, LocalizedDateFormat } from '../../../../utils/date/model/date'
import { Field, reduxForm } from 'redux-form'
import Select from '../../../../components/form/Select'
import { MenuItem } from '@material-ui/core'
import SemainesNonInitialisees from '../component/common/SemainesNonInitialisees'
import { getSyntheseDatas } from '../services/api'

const styles = () => getStyles({
	content: {
		padding: 20,
		fontSize: 16,
		justifyContent: 'center'
	},
	switchText: {
		paddingTop: 20
	}
})

const USE_WEEKS_FIELD = 'useWeeks'
export const LAUNCH_SOLVER_TACHE_FORM = 'LAUNCH_SOLVER_TACHE'

const validate = (values) => {
	const errors = {}
	const requiredFields = [USE_WEEKS_FIELD]
	requiredFields.forEach(field => {
		if ((!values[field]) || (values[field] && values[field].length === 0)) {
			errors[field] = { id: 'global.errors.mandatory' }
		}
	})
	return errors
}

const PopinPlanification = ({ classes, onSubmit, semaineCourante }) => {
	const [jour] = useState(LocalDate.now())
	const [datas, setDatas] = React.useState(undefined)

	React.useEffect(() => {
		getSyntheseDatas(false).then(setDatas)
	}, [])

	/**
	 on peut planifier de la date du jour jusqu'au dimanche dans 3 semaines. Ex: du mardi 17/12 au dimanche 5/01
	 ou pour la date du jour et le lendemain
	 */
	const getDateEnd = (pw) => {
		if (pw.id === 'weeks') {
			return jour.plus(2, DateUnit.week).endOf(DateUnit.week).format(LocalizedDateFormat.LONG_DATE_WITHOUT_YEAR_STRING)
		} else {
			return jour.plus(1, DateUnit.day).format(LocalizedDateFormat.LONG_DATE_WITHOUT_YEAR_STRING)
		}
	}

	return (
		<form className={classes.form} onSubmit={onSubmit}>
			<Grid container className={classes.content}>
				<Typography>
					<FormattedMessage id="gestionTaches.toolbar.popin.runPlanification.description" />
				</Typography>
				{datas && <SemainesNonInitialisees datas={datas} />}
				<Grid xs={8}>
					<Field
						key={`key-${USE_WEEKS_FIELD}`}
						name={USE_WEEKS_FIELD}
						label={<FormattedMessage id={'gestionTaches.toolbar.popin.runPlanification.switch.label'} />}
						component={Select}
					>
						{
							PERIOD_SWITCH.map(pw =>
								<MenuItem key={`week-select-${pw.id}`} value={pw.id}>
									<FormattedMessage id={pw.result} values={{
										dateStart: jour.format(LocalizedDateFormat.LONG_DATE_WITHOUT_YEAR_STRING),
										dateEnd: getDateEnd(pw),
										numeroStart: jour.weekNumber,
										numeroEnd: jour.plus(14).weekNumber
									}} />
								</MenuItem>
							)
						}
					</Field>
				</Grid>
				<Typography>
					<FormattedMessage id="gestionTaches.toolbar.popin.runPlanification.informationNotification" />
				</Typography>
			</Grid>
		</form>
	)
}

export default compose(
	withStyles(styles),
	reduxForm({
		form: LAUNCH_SOLVER_TACHE_FORM,
		validate
	})
)(PopinPlanification)
